import Vue from 'vue'
import configs from '@/config'
import { isFeatureEnabled } from '@/services/unleash'

let resource = null

const actions = {
  createReaction: {
    method: 'POST',
    url: `${configs.baseUrl}/api/reaction/`,
  },
  createReactionV2: {
    method: 'POST',
    url: `${configs.baseUrlLiveApi}/api/stream/reactions`,
  },
}

const initResource = () => {
  resource = Vue.resource('', {}, actions)
}

const createReaction = async (payload) => {
  if (isFeatureEnabled('audience-reaction-emqx')) {
    const res = await resource.createReactionV2(payload)
    return res.body
  }
  const res = await resource.createReaction(payload)
  return res.body
}

export default {
  initResource,
  createReaction,
}
